import { type ReactNode } from 'react'
import { RefreshCw } from 'lucide-react'
import usePullToRefresh from '../../hooks/usePullToRefresh'

interface PullToRefreshProps {
  children: ReactNode
  onRefresh: () => Promise<void> | void
  className?: string
}

export default function PullToRefresh({ children, onRefresh, className }: PullToRefreshProps) {
  const { scrollableRef, pullDistance, refreshing, handlers } = usePullToRefresh({ onRefresh })

  const showIndicator = pullDistance > 10 || refreshing
  const ready = pullDistance >= 60

  return (
    <div
      ref={scrollableRef}
      className={`flex-1 overflow-y-auto relative ${className || ''}`}
      {...handlers}
    >
      {/* Pull indicator */}
      {showIndicator && (
        <div
          className="flex items-center justify-center transition-all duration-150"
          style={{ height: `${pullDistance}px` }}
        >
          <div className={`flex items-center gap-2 text-xs font-medium ${ready || refreshing ? 'text-primary' : 'text-content-muted'}`}>
            <RefreshCw
              size={16}
              className={refreshing ? 'animate-spin' : ''}
              style={{
                transform: !refreshing ? `rotate(${pullDistance * 3}deg)` : undefined,
                transition: 'transform 0.1s',
              }}
            />
            <span>
              {refreshing ? 'Atualizando...' : ready ? 'Solte para atualizar' : 'Puxe para atualizar'}
            </span>
          </div>
        </div>
      )}

      {children}
    </div>
  )
}
